module.exports = __webpack_public_path__ + "static/media/mountains.c07fceaf.png";